import httpRequest from "@/core/http-request"

//数据请求
export const userApi = {
    saveUser(data){
        return httpRequest.post('/user/save', data)
    },
    pageUser(condition){
        return httpRequest.get('/user/page', { params: condition })
    },
    getUserDetail(condition){
        return httpRequest.get("/user/detail",{params: condition})
    },
    deleteUser(ids){
        return httpRequest.post('/user/delete', ids)
    },
    changePassword(data){
        return httpRequest.post('/user/edit/password', data )
    }
}